<clr-alert [clrAlertType]="'danger'" [clrAlertAppLevel]="true" *ngIf="alertService.isVisible.value" (clrAlertClosedChange)="onClose()" class="alert-component">
    <div class="alert-item">
        <span class="alert-text">
            {{alertService?.message?.value}}
        </span>
    </div>
</clr-alert>
